import {
    SpaceBetween,
    Box,
    Grid,
    BreadcrumbGroup,
    Table,
    TextFilter,
    Pagination,
} from '@amzn/awsui-components-console';
import React, { useContext, useEffect, useState } from 'react';
import FilterSet from './FilterSet';
import { getFilterSet, queryMetrics, getColumnDefinitions, filterData, getHeader } from '../../lib/metrics/stats';
import { HOSTS_THING_TYPE, TABLE_LOOK_UP_PLACEHODLER } from '../../lib/metrics/constants';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { RegionContext } from '../../CustomContext';

export default function Stats() {
    const [thingType, setThingType] = useState(HOSTS_THING_TYPE);
    const [filters, setFilters] = useState({});
    const [tableData, setTableData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [tableFilterPlaceHolder, setTableFilterPlaceHolder] = useState(TABLE_LOOK_UP_PLACEHODLER.DFEdges);
    const [filteringText, setFilteringText] = useState('');
    const { selectedRegion, setSelectedRegion } = useContext(RegionContext);

    const filteringField = thingType == HOSTS_THING_TYPE ? 'hostName' : 'dsn';
    const { collectionProps, items, paginationProps } = useCollection(displayData, {
        filtering: {
            fields: [filteringField],
        },
        pagination: { pageSize: 50 },
        sorting: {},
    });

    const textFilter = (row) => {
        if (row[filteringField]) {
            return row[filteringField].includes(filteringText);
        }
        return filteringText ? false : true;
    };

    useEffect(() => {
        setIsLoading(true);
        setFilteringText('');
        queryMetrics(thingType, selectedRegion.value).then((data) => {
            setTableData(data);
            setIsLoading(false);
            const filterSet = getFilterSet(thingType, data);
            setFilters(filterSet);
        });
        setTableFilterPlaceHolder(TABLE_LOOK_UP_PLACEHODLER[thingType]);
    }, [thingType]);

    useEffect(() => {
        filterData(tableData, filters, textFilter).then((result) => {
            setDisplayData(result);
        });
    }, [tableData, filteringText]);

    const onThingTypeChange = (detail) => {
        setThingType(detail.value);
    };

    const onClearFilterClick = () => {
        const filterSet = getFilterSet(thingType, tableData);
        setFilters(filterSet);
        setFilteringText('');
        setDisplayData(tableData);
    };

    const onFiltersChange = (filters) => {
        filterData(tableData, filters, textFilter).then((result) => {
            setDisplayData(result);
            const filterSet = getFilterSet(thingType, result);
            for (const key in filters) {
                filterSet[key].selectedOption = filters[key].selectedOption;
            }
            setFilters(filterSet);
        });
    };

    return (
        <SpaceBetween size="l">
            <Box>
                <BreadcrumbGroup
                    items={[
                        { text: 'Amazon Device Farm', href: '#' },
                        { text: 'Metadata', href: '#/metrics/metadata' },
                    ]}
                    ariaLabel="Breadcrumbs"
                />
            </Box>
            <Box variant="small" textAlign="left" fontWeight="bold" padding="n" fontSize="heading-m" color="inherit">
                Welcome to Amazon Device Farm - Metadata
            </Box>
            <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                <FilterSet
                    filters={filters}
                    onFilterChange={onFiltersChange}
                    onThingTypeChange={onThingTypeChange}
                    onClearFilterClick={onClearFilterClick}
                    thingType={thingType}
                />
                <div>
                    {thingType != null && (
                        <Table
                            {...collectionProps}
                            columnDefinitions={getColumnDefinitions(thingType)}
                            loadingText="Loading..."
                            loading={isLoading}
                            header={getHeader(thingType, displayData)}
                            items={items}
                            pagination={<Pagination {...paginationProps} />}
                            filter={
                                <TextFilter
                                    filteringText={filteringText}
                                    onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                    filteringPlaceholder={tableFilterPlaceHolder}
                                />
                            }
                        />
                    )}
                </div>
            </Grid>
        </SpaceBetween>
    );
}
